module.exports = __webpack_public_path__ + "img/products_big_can_marmelade.11cdf5f1.png";